import { render, staticRenderFns } from "./SpousalSupportIncomeAndEarningPotential.vue?vue&type=template&id=3ddd6fa3"
import script from "./SpousalSupportIncomeAndEarningPotential.vue?vue&type=script&lang=ts"
export * from "./SpousalSupportIncomeAndEarningPotential.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports